import Box from "@mui/material/Box";
import Link from "next/link";
import { useRouter } from "next/router";

import { useI18n } from "@/i18n/I18nProvider";

import UserDropDown from "../UserDropDown/UserDropDown";
import { styless } from "./User_Navbar";

/* Routes shown as tabs in the signed-in header, in order. */
const ACCOUNT_TABS = [
  { href: "/contract", label: (t) => t.userNav.your_installement },
  { href: "/customerservices", label: (t) => t.userNav.call_center },
];

const TAB_STYLE = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "14px",
  textDecoration: "none",
  transition: "1s",
};

/* The header for the signed-in account area (/profile, /contract, ...). */
export default function UserNavbar({ onLogout }) {
  const router = useRouter();
  const { t } = useI18n();

  return (
    <Box sx={styless.container} className="horizontal-safe-padding">
      <Link href="/">
        <Box
          component="img"
          src={t.logo}
          alt="Contact"
          loading="lazy"
          sx={{
            width: { xs: "80px", sm: "80px", md: "100px" },
            height: { xs: "25px", md: "26px" },
          }}
        />
      </Link>

      {ACCOUNT_TABS.map(({ href, label }) => {
        const isActive = router.pathname === href;

        return (
          <Box
            key={href}
            component={Link}
            href={href}
            sx={{
              ...TAB_STYLE,
              /* Tabs are hidden on phones; the dropdown carries them there. */
              display: { xs: "none", md: "flex" },
              color: isActive ? "#2D317F" : "#040921",
              fontWeight: isActive ? "800" : "",
            }}
          >
            {label(t)}
          </Box>
        );
      })}

      <Box sx={{ marginInlineStart: "auto" }}>
        <UserDropDown onLogout={onLogout} />
      </Box>
    </Box>
  );
}
